import React, { forwardRef } from 'react';
import IconType from './iconType';

const LinkIcon = forwardRef<SVGSVGElement, IconType>(({ color = '#7F38E9', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      ref={ref}
    >
      <title>Link Icon</title>
      <path
        d="M14.1693 16.6693H5.0026C4.56058 16.6693 4.13665 16.4937 3.82409 16.1811C3.51153 15.8686 3.33594 15.4446 3.33594 15.0026V5.83594C3.33594 5.39391 3.51153 4.96999 3.82409 4.65743C4.13665 4.34487 4.56058 4.16927 5.0026 4.16927H8.33594V5.83594H5.0026V15.0026H14.1693V11.6693H15.8359V15.0026C15.8359 15.4446 15.6603 15.8686 15.3478 16.1811C15.0352 16.4937 14.6113 16.6693 14.1693 16.6693ZM9.7526 11.4251L8.5776 10.2468L13.8218 5.0026H10.8359V3.33594H16.6693V9.16927H15.0026V6.18177L9.7526 11.4251Z"
        fill={color}
      />
    </svg>
  );
});

LinkIcon.displayName = 'LinkIcon';

export default LinkIcon;
